import { css } from 'styled-components';

export const form = () => css`
  textarea {
    resize: vertical;
  }
`;
